import React from 'react';

import { Link } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro';

export default function DetailPanelToggle({ id }: GridRenderCellParams) {
  const apiRef = useGridApiContext();
  return (
    <Link
      component="button"
      underline="hover"
      onClick={(event) => {
        apiRef.current.toggleDetailPanel(id);
        event.stopPropagation();
      }}
    >
      More Details
    </Link>
  );
}
